import { useQuery } from '@tanstack/react-query'
import { getPositionTemplates } from 'api/company/positionTemplates'
import { useAuthContext } from 'components/auth/useAuthContext'
import { positionTemplatesKey } from 'queries/company/keys'

export function usePositionTemplates() {
  const { company } = useAuthContext()

  return useQuery({
    queryKey: positionTemplatesKey,
    queryFn: () => {
      const companyId = company?.id
      if (!companyId) {
        throw new Error('Company ID not found')
      }

      return getPositionTemplates(companyId)
    },
    gcTime: 1000 * 60 * 60, // cached for 1 hour since this data rarely changes
    enabled: Boolean(company?.id),
  })
}
